/**
 * ProductModal - Custom element for product media modal/lightbox
 * Requires ModalDialog to be defined (from global.js)
 */
if (!customElements.get('product-modal')) {
  // Wait for ModalDialog to be available before defining ProductModal
  const defineProductModal = () => {
    if (typeof ModalDialog === 'undefined') {
      // ModalDialog not yet loaded, wait a bit
      setTimeout(defineProductModal, 50);
      return;
    }

    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          
          const mediaId = this.openedBy.getAttribute('data-media-id');
          const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
          const activeMediaTemplate = activeMedia?.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia?.classList.add('active');
          activeMedia?.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          if (container && activeMedia) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }

          if (
            activeMedia?.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }
      }
    );
  };

  defineProductModal();
}
